import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { BENEFITS } from "../data/content";

// Asymmetric bento sizing
const spans = [
  "sm:col-span-2 lg:col-span-2",
  "lg:col-span-2",
  "",
  "",
  "sm:col-span-2 lg:col-span-2",
  "",
  "",
];

const Benefits = () => {
  return (
    <section className="relative bg-secondary/40 py-24 sm:py-32 lg:py-40" data-testid="benefits-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <Reveal className="mb-16 max-w-3xl">
          <Eyebrow>07 — Customer Benefits</Eyebrow>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Outcomes your organisation can measure.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => {
            const Icon = Icons[b.icon] || Icons.Sparkles;
            return (
              <Reveal key={b.title} delay={i * 0.05} className={spans[i]}>
                <motion.div
                  whileHover={{ y: -5 }}
                  className={`group relative flex h-full min-h-[160px] flex-col justify-between overflow-hidden rounded-3xl border border-border p-7 transition-colors ${
                    i === 0 ? "bg-navy text-white" : "bg-card"
                  }`}
                  data-testid={`benefit-${i}`}
                >
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-xl ${
                      i === 0 ? "bg-white/15 text-white" : "bg-teal/10 text-teal"
                    }`}
                  >
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </span>
                  <h3 className={`mt-6 font-display text-xl font-semibold ${i === 0 ? "text-white" : "text-foreground"}`}>
                    {b.title}
                  </h3>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
